module.exports = __webpack_public_path__ + "static/darren-9f2174f867f8bf4f2eb5adf4bf0c0ac4.png";